import React from 'react'
// Ant Design
import { Flex, Typography } from 'antd'
// Layouts
import { Linea } from '../../Layout/GraphsData/Linea'
import { Pastel } from '../../Layout/GraphsData/Pastel'
import { Barras } from '../../Layout/GraphsData/Barras'
import { Dona } from '../../Layout/GraphsData/Dona'
import { Range } from '../../Layout/GraphsData/Range'
import { Card } from '../../Layout/GraphsData/Card'
// Config
import { getConfig } from '../../config'
const { Title } = Typography

export const ViewGraph = ({ views }) => {
    return (
        <Flex style={{ width: "75%", height: "100%", padding: "0 0 0 10px" }}>
            <Flex wrap style={{ width: "100%", height: "100%", backgroundColor: "#F5F7FA", borderRadius: "10px", overflowY: "auto", overflowX: "hidden" }}>
                {views.map(graph => (
                    <Flex key={graph.report_name} className="animate__animated animate__fadeInLeft" vertical justify="center" align="center" style={{ width: "50%", height: "320px" }}>
                        <Title level={4} style={{ color: getConfig("colorSecundario"), marginBottom: "10px" }}>{graph.report_name}</Title>
                        {
                            (graph.graph_type === "Lineas" || graph.graph_type === "lineas") ? <Linea graph={null} /> :
                            (graph.graph_type === "Pastel" || graph.graph_type === "pastel") ? <Pastel graph={null} /> :
                            (graph.graph_type === "Barras" || graph.graph_type === "barras") ? <Barras graph={null} /> :
                            (graph.graph_type === "Dona" || graph.graph_type === "dona") ? <Dona graph={null} /> :
                            (graph.graph_type === "Medidor" || graph.graph_type === "medidor") ? <Range graph={null} /> :
                            (graph.graph_type === "Card" || graph.graph_type === "card") ? <Card graph={null} size={"sm"} />: null
                        }
                    </Flex>
                ))}
            </Flex>
        </Flex>
    )
}
